export default __webpack_public_path__ + "static/article3-a3831c5660d15fbefd6bfe53e7940bdb.jpg";